<template>
	<div
		class="am-down"
		:class="{ 'has-text': text }"
		@click="$emit('click', $event)"
	>
		<am-icon
			class="am-down__angle"
			name="angle-down"
			size="sm"
			:dark="true"
		/>

		<am-text class="am-down__text" type="caption">
			{{ text }}
		</am-text>
	</div>
</template>

<script>
import AMIcon from '@/components/atoms/AMIcon'
import AMText from '@/components/atoms/AMText'

export default {
	props: {
		text: {
			type: String,
			default: null
		}
	},
	components: {
		'am-icon': AMIcon,
		'am-text': AMText,
	}
}
</script>

<style lang="scss">
.am-down{
	width: 80px;
	height: 40px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	&:before{
		content: "";
		position: absolute;
		width: 80px;
		height: 80px;
		border-radius: 80px;
		background: rgba(black, .3);
		transition: .2s $easeInOutQuad;
		top: 0;
		left: 0;
	}
	&__angle{
		color: white;
		line-height: 70%;
		animation-name: angle-down;
		animation-duration: 1.5s;
		animation-iteration-count: infinite;
		transition: .2s $easeInOutQuad;
	}
	&__text{
		color: white;
		position: absolute;
		bottom: 4px;
		left: 50%;
		transform: translateX(-50%);
		transition: .2s $easeInOutQuad;
		opacity: 0;
	}
	
	&.has-text{
		.am-down{
			&__angle{
				margin-top: -15px;
			}
			&__text{
				opacity: 1;
			}
		}
		&:before{
			background: $c-brown;
		}
	}

	@keyframes angle-down{
		0% {
			transform: translateY(0px);
		}
		50% {
			transform: translateY(5px);
		}
		100% {
			transform: translateY(0px);
		}
	}
}
</style>
